/**
 * Hook to fetch knowledge sources linked to an agent configuration
 */

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AgentKnowledgeSource, agentsApi } from "../api";

export const useAgentKnowledgeSources = (
  agentConfigId: string
): UseQueryResult<AgentKnowledgeSource[], Error> => {
  return useQuery<AgentKnowledgeSource[], Error>({
    queryKey: ["ai-studio", "agents", agentConfigId, "knowledge"],
    queryFn: () => agentsApi.listKnowledgeSources(agentConfigId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
    enabled: !!agentConfigId
  });
};
